import React, { createContext, useContext, useState } from "react";

const ChatContext = createContext();

export const useChat = () => {
    const context = useContext(ChatContext);
    if (!context) {
        throw new Error("useChat must be used within a ChatProvider");
    }
    return context;
};

export const ChatProvider = ({ children }) => {
    const [chatState, setChatState] = useState({
        active_user: 3,
        users: [],
        groups: [],
        contacts: [],
    });

    const chatUser = () => {
        // No state change needed, just returns current state
        return chatState;
    };

    const setActiveUser = (payload) => {
        setChatState((prev) => ({
            ...prev,
            active_user: payload,
        }));
    };

    const setFullUser = (payload) => {
        setChatState((prev) => ({
            ...prev,
            users: payload,
        }));
    };

    const addLoggedUser = (payload) => {
        setChatState((prev) => ({
            ...prev,
            users: [...prev.users, payload],
        }));
    };

    const createGroup = (payload) => {
        setChatState((prev) => ({
            ...prev,
            groups: [...prev.groups, payload],
        }));
    };

    const value = {
        ...chatState,
        chatUser,
        setActiveUser,
        setFullUser,
        addLoggedUser,
        createGroup,
    };

    return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};
